import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import ReportsEntryPoint from "../../pages/Leads/ReportsEntryPoint/ReportsEntryPoint";
import { ReportsContainerProps } from "../../interfaces/containers";
import { getGeneralReport, getDealershipReport } from "../../actions/reports";
import { getDealerships } from "../../actions/dealerships";

function mapStateToProps(state: ReportsContainerProps) {
    return{
        fetchingReports: state.reports.fetching,
        generalReport: state.reports.generalReport,
        dealershipReport: state.reports.dealershipReport,
        dealerships: state.dealerships
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getGeneralReport,
        getDealershipReport,
        getDealerships
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsEntryPoint);
